export default class SubstanceListsCacheManager {
    constructor({ fetcher, ttlMs, cacheEnabled, stateRef, cacheRef, setState, setCache }) {
        this.fetcher = fetcher
        this.ttlMs = ttlMs
        this.cacheEnabled = cacheEnabled
        this.stateRef = stateRef
        this.cacheRef = cacheRef
        this.setState = setState
        this.setCache = setCache
    }

    updateConfig({ fetcher, ttlMs, cacheEnabled }) {
        if (fetcher) {
            this.fetcher = fetcher
        }
        if (Number.isFinite(ttlMs)) {
            this.ttlMs = ttlMs
        }
        if (typeof cacheEnabled === 'boolean') {
            this.cacheEnabled = cacheEnabled
        }
    }

    ensure(substanceId) {
        if (!substanceId || !this.fetcher) {
            return Promise.resolve(null)
        }
        const now = Date.now()
        const cacheEntry = this.cacheRef[substanceId]
        const state = this.stateRef[substanceId]
        const isFresh = this.cacheEnabled
            && cacheEntry
            && cacheEntry.ts
            && (now - cacheEntry.ts) < this.ttlMs
            && state
            && !state.loading

        if (isFresh) {
            return Promise.resolve(state.lists || [])
        }
        if (cacheEntry && cacheEntry.promise) {
            return cacheEntry.promise
        }

        this.setState(substanceId, { lists: [], loading: true, error: false })
        const request = this.fetcher(substanceId)
            .then(response => {
                const lists = Array.isArray(response && response.data) ? response.data : []
                this.setState(substanceId, { lists, loading: false, error: false })
                if (this.cacheEnabled) {
                    this.setCache(substanceId, { ts: Date.now() })
                } else {
                    this.setCache(substanceId, { ts: 0 })
                }
                return lists
            })
            .catch(() => {
                this.setState(substanceId, { lists: [], loading: false, error: true })
                return []
            })
            .finally(() => {
                const entry = this.cacheRef[substanceId]
                if (entry && entry.promise) {
                    this.setCache(substanceId, { ts: entry.ts || 0 })
                }
            })

        this.setCache(substanceId, {
            ts: cacheEntry && cacheEntry.ts ? cacheEntry.ts : 0,
            promise: request,
        })
        return request
    }
}
